module.exports = __webpack_public_path__ + "static/media/header-960.4aae87a1.jpg";